var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyInboxChatbot = function SvgImgEmptyInboxChatbot(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    transform: "translate(9 19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M8 24a7.227 7.227 0 0 0 0 14.454M54 24a7.227 7.227 0 0 1 0 14.454"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 35,
    x: 8,
    y: 14,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.533 37.127c0 2.692 2.91 4.875 6.5 4.875s6.5-2.183 6.5-4.875M16 26.017a3.835 3.835 0 0 0 7.67 0m14.65 0a3.84 3.84 0 0 0 7.68 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 5,
    r: 5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 10v3.614"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43 49)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M0 5.22c3.233 1.43 6.674.546 10.322-2.65C15.795-2.225 23 .04 23 6.454s-7.988 9.31-14.186 6.414C4.682 10.937 1.744 8.388 0 5.22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    d: "M16 3.106c2.135-.446 3.429.518 3.88 2.894"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.15,
    cy: 9.15,
    r: 1.15,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62 14h6.191L62 20.547h6.191M64.5 16.5l2 2m-7 7 1 1M58 24h4l-4 4.23h4",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    d: "M22.078 9c.622 0 1.225.08 1.8.23a5.898 5.898 0 0 0 4.123 10.724A7.077 7.077 0 1 1 22.078 9zM8.33 34.755l-3.294 1.383.298-3.56L3 29.872l3.478-.817L8.33 26l1.852 3.055 3.478.817-2.334 2.706.298 3.56zm66.05 4.44-2.707 1.136.245-2.926L70 35.182l2.858-.671L74.38 32l1.522 2.511 2.858.671-1.918 2.223.245 2.926z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyInboxChatbot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-inbox-chatbot.29960d0290d391c18b9d853c00e2b8fc.svg";